/*
 * @Descripttion: 历史记录
 * @Author: zenghua.wang
 * @Date: 2022-01-14 10:19:29
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-21 16:14:18
 */

import { getStore } from '@/framework/util/store'
import { isEmpty, deepClone, isEqual } from '@/dragComponents/utils'

const historyOptions = {
  key: 'history-records',
  maxStack: 50, // 最多50步
  autoUpdate: false, // 自动更新
  delay: 10000 // 10s
}

function diff(value, other) {
  return isEqual(value, other)
}

// eslint-disable-next-line no-unused-vars
export default class HistoryRecord {
  constructor(options) {
    const { maxStack, autoUpdate, delay, key } = Object.assign(
      historyOptions,
      options
    )
    this.actionPoints = [] // 快照数组
    this.step = 0 // 当前位置
    this.maxStack = maxStack // 最大步数
    this.delay = delay
    this.autoUpdate = autoUpdate
    this.updateTime = 0 // 上次的操作时间
    this.key = key
    this.isUndo = false
    this.isRedo = false
  }

  init(data) {
    if (data?.storage) {
      const records = getStore({ name: this.key })
      if (!isEmpty(records)) {
        this.actionPoints[this.step] = JSON.parse(records)
        return deepClone(JSON.parse(records))
      }
    }

    this.actionPoints[this.step] = deepClone(data)
    return data
  }

  push(data, type = 'add') {
    const curTime = Date.now()
    if (type === 'update') {
      const equal = diff(data, this.actionPoints[this.step])
      if (equal) return
      if (this.autoUpdate) {
        if (curTime - this.updateTime < this.delay) {
          this.update(data)
          return
        }
      } else {
        this.update(data)
        return
      }
    }

    if (this.step === this.maxStack - 1) {
      this.actionPoints.shift()
    } else {
      this.step++
    }
    this.actionPoints[this.step] = deepClone(data)

    if (this.step < this.actionPoints.length - 1) {
      this.actionPoints = this.actionPoints.slice(0, this.step + 1)
    }
    this.reset()
  }

  undo() {
    if (this.step !== 0) this.step--
    this.reset()
    return deepClone(this.actionPoints[this.step])
  }

  redo() {
    if (this.step !== this.actionPoints.length - 1) this.step++
    this.reset()
    return deepClone(this.actionPoints[this.step])
  }

  update(data) {
    if (this.step === this.maxStack - 1) {
      this.actionPoints.shift()
    } else {
      this.step++
    }
    this.actionPoints[this.step] = deepClone(data)
    this.reset()
  }

  reset() {
    this.updateTime = Date.now()
    this.isUndo = this.step !== 0
    this.isRedo = this.step !== this.actionPoints.length - 1
  }
}
